import Icons from "../../../../../shared/constants/icon.constant";
import Banking from "../pages/Banking";
import Deposit from "../pages/Deposit";
import Wallet from "../pages/Wallet";
import Withdrawal from "../pages/Withdrawal";

const assetRoutes = {
  path: "assets",
  label: "Assets",
  icon: Icons.Assets({ width: 16, height: 16 }),
  children: [
    {
      path: "banking",
      label: "Banking",
      icon: Icons.Banking({ width: 16, height: 16 }),
      element: <Banking />,
    },
    {
      path: "wallet",
      label: "Wallet",
      icon: Icons.Wallet({ width: 16, height: 16 }),
      element: <Wallet />,
    },
    {
      path: "deposit",
      label: "Deposit",
      icon: Icons.Deposit({ width: 16, height: 16 }),
      element: <Deposit />,
    },
    {
      path: "withdrawal",
      label: "Withdrawal",
      icon: Icons.Withdrawal({ width: 16, height: 16 }),
      element: <Withdrawal />,
    },
  ],
};
export default assetRoutes;
